import React from "react";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import {Switcher, SwitcherPill, SwitcherPillInactive} from "./AppModeSwitcher.style";
import {DashboardIcon} from "../../../icons/DashboardIcon";
import {MenuIcon} from "../../../icons/MenuIcon";
import {Tooltip} from "../../cms/Tooltip";

export const AppModeSwitcher = () => {
    const {t} = useTranslation();
    const {cmsActive} = useSelector(state => state.globalParams.globalParams);

    return (
        <Switcher>
            {cmsActive &&
                <Tooltip topOffset={-20} content={t('dashboard')}>
                    <SwitcherPillInactive $cmsActive={cmsActive}>
                        <DashboardIcon/>
                    </SwitcherPillInactive>
                </Tooltip>
            }
            <Tooltip topOffset={-20} content={cmsActive ? t('menu') : t('dashboard')}>
                <SwitcherPill $cmsActive={cmsActive}>
                    {cmsActive ? <MenuIcon fill={'#FFF'}/> : <DashboardIcon fill={'#FFF'}/>}
                </SwitcherPill>
            </Tooltip>
            {!cmsActive &&
                <Tooltip topOffset={-20} content={t('menu')}>
                    <SwitcherPillInactive $cmsActive={cmsActive}>
                        <MenuIcon/>
                    </SwitcherPillInactive>
                </Tooltip>
            }
        </Switcher>
    );
}